"use client";

import Image from "next/image";
import { css } from "styled-system/css";

export function TradeLoudBanner() {
  return (
    <div
      className={css({
        w: "full",
        maxW: "[1244px]",
        mx: "auto",
        py: { base: "40", md: "72" },
        px: { base: "16", md: "24" },
      })}
    >
      <div
        className={css({
          w: "full",
          position: "relative",
          overflow: "hidden",
          rounded: { base: "200", md: "300" },
        })}
      >
        <Image
          src="/images/pre-deposits/informational-phase.webp"
          alt="Trade Loud"
          width={1196}
          height={259}
          className={css({ w: "full", h: "auto", display: "block" })}
          priority
        />
      </div>
    </div>
  );
}
